import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Proveedor } from "@/shared/types/proveedor";

export async function checkProveedor(numDocumento: string): Promise<Proveedor | null> {
    await sleep(1000);
    const { data } = await api.get("proveedores/check/" + numDocumento);
    return data?data:null;
}

export function useCheckProveedorQuery(numDocumento: string, queryConfig: QueryConfig<Proveedor | null> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await checkProveedor(numDocumento),
        queryKey: ["proveedores", "check", numDocumento],
    })
}

export interface CheckProveedorQueryProps {
    numDocumento: string,
    queryConfig?: QueryConfig<Proveedor | null>,
    children?: (queryResult: QueryResult<Proveedor | null>) => ReactNode
}

export function CheckProveedorQuery({
    numDocumento,
    children,
    queryConfig
}: CheckProveedorQueryProps) {
    const queryResult = useCheckProveedorQuery(numDocumento, queryConfig);
    return children && children(queryResult);
}